import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { campaignAction } from "../../store/campaign-store";
import { cuteToast } from "../UI/cute";

const SingleSlide = (props) => {
  const dispatch = useDispatch();

  const { single_slide, id } = props;

  const video_data = useSelector((state) => state.campaign.video_data);
  const active_slide_index = useSelector(
    (state) => state.campaign.active_slide_index
  );
  const active_slide_name = useSelector(
    (state) => state.campaign.active_slide_name
  );
  const new_slide_index = useSelector(
    (state) => state.campaign.new_slide_index
  );

  const [verticalContent, setVerticalContent ] = useState("");
  const [vheight , setVheight] = useState('100');


  const get_lastcharacter = (datastring) => {
    let lastcharacter = datastring.slice(-1);
    return lastcharacter;
  };

  useEffect(() => {
    if (!active_slide_index) {
      makeActiveSlide(0);
    }
    // console.log(active_slide_index);
    if(active_slide_name && (active_slide_name.includes("pq_slide_") || active_slide_name.includes("va_slide_") ) && (get_lastcharacter(active_slide_name) === 'v') ){
      // console.log("vertical slide");
      setVerticalContent('verticalContent');
      setVheight('130');
    }else{
      setVerticalContent('');
      setVheight('100');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [active_slide_name]);

  useEffect(() => {
    if (new_slide_index !== null) {
      // console.log(new_slide_index);
      makeActiveSlide(new_slide_index);
      dispatch(campaignAction.makeNullIndex({ new_slide_index: null }));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [new_slide_index]);

  useEffect(() => {
    // console.log(video_data.length);
    if (video_data.length >= 1) {
      // eslint-disable-next-line array-callback-return
      const total_duration = video_data.reduce(
        (total, slide) => total + parseInt(slide.duration),
        0
      );
      dispatch(campaignAction.setVideoDuration({ total_duration }));
      // console.log(total_duration);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [video_data]);

  const makeActiveSlide = (key) => {
    // console.log(key);
    var previewData = video_data;
    // console.log(previewData);
    if (previewData.length === 0) return false;
    // console.log(previewData[key].temp_name);

    if(previewData[key] && previewData[key].temp_name){
      var temp_name = previewData[key].temp_name;
      var temp_type = "";
      if( temp_name && ( temp_name.includes("pq_slide_") || temp_name.includes("va_slide_") ) && (get_lastcharacter(temp_name) === 'v') ){
        temp_type = "Vertical";
      }else if(temp_name && ( temp_name.includes("pq_slide_") || temp_name.includes("va_slide_") ) && temp_name.includes("w")){
        temp_type = "Wide";
      }else if(temp_name && ( temp_name.includes("pq_slide_") || temp_name.includes("va_slide_") ) && temp_name.includes("b")){
        temp_type = "Box"; 
      }else{
        temp_type = "FHD";
      }


    }

    dispatch(
      campaignAction.doActiveSlide({
        active_slide_index: key,
        active_slide_type: temp_type,
        active_slide_name: previewData[key].temp_name,
        active_slide_duration: previewData[key].duration,
        single_slide_data: previewData[key],
      })
    );

    var data = previewData[key];

    var dummyData = {};
    var assets = data.assets;
    
    assets.map((slide) => {
      // console.log(slide);
      // return false;

      if (slide.layerName === "hello" && slide.text) {
        dummyData.hello = slide.text;
        
      }

      if (slide.layerName === "bg_color" && slide.text) {
        dummyData.bg_color = slide.text;
      }

      if (slide.layerName === "bg_color_1" && slide.text) {
        dummyData.bg_color_1 = slide.text;
      }

      if (slide.layerName === "bg_color_stroke" && slide.text) {
        dummyData.bg_color_stroke = slide.text;
      }

      if (slide.layerName === "hey" && slide.text) {
        dummyData.hey = slide.text;
        
      }

      if (slide.layerName === "home A" && slide.text) {
        // dummyData.text = slide.text.replace("  ", "<br />");
        dummyData.home_a = slide.text;
        
      }

      if (slide.layerName === "home B" && slide.text) {
        dummyData.home_b = slide.text;
        
      }

      if (slide.layerName === "home C" && slide.text) {
        dummyData.home_c = slide.text;
      }

      if (slide.layerName === "number" && slide.text) {
        dummyData.number = slide.text;
        
      }

      if (slide.layerName === "problem A" && slide.text) {
        dummyData.problem_a = slide.text;
        
      }

      if (slide.layerName === "problem B" && slide.text) {
        dummyData.problem_b = slide.text;
        
      }

      if (slide.layerName === "problem C" && slide.text) {
        dummyData.problem_c = slide.text;
        
      }

      if (slide.layerName === "problem D" && slide.text) {
        dummyData.problem_d = slide.text;
        
      }

      if (slide.layerName === "trust A" && slide.text) {
        dummyData.trust_a = slide.text;
        
      }

      if (slide.layerName === "trust B" && slide.text) {
        dummyData.trust_b = slide.text;
        
      }

      if (slide.layerName === "trust C" && slide.text) {
        dummyData.trust_c = slide.text;
        
      }

      if (slide.layerName === "resolve A" && slide.text) {
        dummyData.resolve_a = slide.text;
        
      }

      if (slide.layerName === "resolve B" && slide.text) {
        dummyData.resolve_b = slide.text;
        
      }

      if (slide.layerName === "resolve C" && slide.text) {
        // dummyData.resolve_c = slide.text;
        dummyData.resolve_c = slide.text.replace("  ", "<br />");
        
      }

      if (slide.layerName === "resolve D" && slide.text) {
        dummyData.resolve_d = slide.text.replace("  ", "<br />");
        
      }

      if (slide.layerName === "resolve E" && slide.text) {
        dummyData.resolve_e = slide.text.replace("  ", "<br />");
        
      }

      if (slide.layerName === "resolve F" && slide.text) {
        dummyData.resolve_f = slide.text.replace("  ", "<br />");
        
      }

      if (
        (slide.layerName === "solution A" ||
          slide.layerName === "solutions A") &&
        slide.text
      ){
        dummyData.solution_a = slide.text;
        dummyData.solutions_a = slide.text;
       
      }

      if (
        (slide.layerName === "solution B" ||
          slide.layerName === "solutions B") &&
        slide.text
      ){
        dummyData.solution_b = slide.text;
        dummyData.solutions_b = slide.text;
      }
      if (
        (slide.layerName === "solution C" ||
          slide.layerName === "solutions C") &&
        slide.text
      ){
        dummyData.solution_c = slide.text;
        dummyData.solutions_c = slide.text;
      }
      
      if (slide.layerName === "solution D" && slide.text)
        dummyData.solution_d = slide.text;

      if (slide.layerName === "logo" && slide.src) {
        dummyData.logo = slide.src;
        dummyData.default_logo = slide.default_src;
      }

      if (slide.layerName === "bg_image" && slide.src) {
        dummyData.bg_image = slide.src;
        dummyData.default_bg_image = slide.default_src;
      }

      if (slide.layerName === "bg_image_1" && slide.src) {
        dummyData.bg_image_1 = slide.src;
        dummyData.default_bg_image_1 = slide.default_src;
      }

      if (slide.layerName === "bg_image_2" && slide.src) {
        dummyData.bg_image_2 = slide.src;
        dummyData.default_bg_image_2 = slide.default_src;
      }

      if (slide.layerName === "bg_image_3" && slide.src) {
        dummyData.bg_image_3 = slide.src;
        dummyData.default_bg_image_3 = slide.default_src;
      }

      if (slide.layerName === "bg_image1" && slide.src) {
        dummyData.bg_image1 = slide.src;
        dummyData.default_bg_image1 = slide.default_src;
      }

      if (slide.layerName === "bg_image2" && slide.src) {
        dummyData.bg_image2 = slide.src;
        dummyData.default_bg_image2 = slide.default_src;
      }

      if (slide.layerName === "bg_image3" && slide.src) {
        dummyData.bg_image3 = slide.src;
        dummyData.default_bg_image3 = slide.default_src;
      }

      if (slide.layerName === "bg_video" && slide.src) {
        dummyData.bg_video = slide.src;
      }

      if (
        (slide.layerName === "website" ||
          slide.layerName === "web_url" ||
          slide.layerName === "website_url") &&
        slide.text
      ) {
        dummyData.website = slide.text;
      }

      if (slide.layerName === "contact A" && slide.text) {
        dummyData.contact_a = slide.text;
      }

      if (slide.layerName === "contact B" && slide.text) {
        dummyData.contact_b = slide.text;
      }

      if (slide.layerName === "pamper A" && slide.text)
        dummyData.pamper_a = slide.text;

      if (slide.layerName === "pamper B" && slide.text)
        dummyData.pamper_b = slide.text;
      if (slide.layerName === "pamper C" && slide.text)
        dummyData.pamper_c = slide.text;

      if (slide.layerName === "pamper D" && slide.text)
        dummyData.pamper_d = slide.text;

      if (slide.layerName === "service A" && slide.text)
        dummyData.service_a = slide.text;
      if (slide.layerName === "service B" && slide.text)
        dummyData.service_b = slide.text;
      if (slide.layerName === "service C" && slide.text)
        dummyData.service_c = slide.text;

      if (slide.layerName === "plan A" && slide.text)
        dummyData.plan_a = slide.text;
      if (slide.layerName === "plan B" && slide.text)
        dummyData.plan_b = slide.text;

      if (slide.layerName === "customer A" && slide.text)
        dummyData.customer_a = slide.text;
      if (slide.layerName === "customer B" && slide.text)
        dummyData.customer_b = slide.text;
      if (slide.layerName === "customer C" && slide.text)
        dummyData.customer_c = slide.text;

      if (slide.layerName === "customer D" && slide.text)
        dummyData.customer_d = slide.text;

      if (slide.layerName === "feel A" && slide.text)
        dummyData.feel_a = slide.text;
      if (slide.layerName === "feel B" && slide.text)
        dummyData.feel_b = slide.text;

      if (slide.layerName === "spot A" && slide.text)
        dummyData.spot_a = slide.text;

      if (slide.layerName === "spot B" && slide.text)
        dummyData.spot_b = slide.text;

      if (slide.layerName === "business A" && slide.text)
        dummyData.business_a = slide.text;
      if (slide.layerName === "business B" && slide.text)
        dummyData.business_b = slide.text;
      if (slide.layerName === "business C" && slide.text)
        dummyData.business_c = slide.text;

      if (slide.layerName === "expert A" && slide.text)
        dummyData.expert_a = slide.text;
      if (slide.layerName === "expert B" && slide.text)
        dummyData.expert_b = slide.text;

      if (slide.layerName === "serve A" && slide.text)
        dummyData.serve_a = slide.text;
      if (slide.layerName === "serve B" && slide.text)
        dummyData.serve_b = slide.text;
      if (slide.layerName === "serve C" && slide.text)
        dummyData.serve_c = slide.text;

      if (slide.layerName === "serve D" && slide.text)
        dummyData.serve_d = slide.text;

      if (slide.layerName === "certified A" && slide.text)
        dummyData.certified_a = slide.text;
      if (slide.layerName === "certified B" && slide.text)
        dummyData.certified_b = slide.text;
      if (slide.layerName === "certified C" && slide.text)
        dummyData.certified_c = slide.text;

      if (slide.layerName === "experienced A" && slide.text)
        dummyData.experienced_a = slide.text;
      if (slide.layerName === "experienced B" && slide.text)
        dummyData.experienced_b = slide.text;

      if (slide.layerName === "guidance A" && slide.text)
        dummyData.guidance_a = slide.text;
      if (slide.layerName === "guidance B" && slide.text)
        dummyData.guidance_b = slide.text;
      if (slide.layerName === "guidance C" && slide.text)
        dummyData.guidance_c = slide.text;

      if (slide.layerName === "help A" && slide.text)
        dummyData.help_a = slide.text;
      if (slide.layerName === "help B" && slide.text)
        dummyData.help_b = slide.text;

      if (slide.layerName === "assessment A" && slide.text)
        dummyData.assessment_a = slide.text;
      if (slide.layerName === "assessment B" && slide.text)
        dummyData.assessment_b = slide.text;
      if (slide.layerName === "assessment C" && slide.text)
        dummyData.assessment_c = slide.text;

      if (slide.layerName === "window A" && slide.text)
        dummyData.window_a = slide.text;
      if (slide.layerName === "window B" && slide.text)
        dummyData.window_b = slide.text;
      if (slide.layerName === "window C" && slide.text)
        dummyData.window_c = slide.text;

      if (slide.layerName === "demand A" && slide.text)
        dummyData.demand_a = slide.text;
      if (slide.layerName === "demand B" && slide.text)
        dummyData.demand_b = slide.text;
      if (slide.layerName === "demand C" && slide.text)
        dummyData.demand_c = slide.text;

      if (slide.layerName === "demand D" && slide.text)
        dummyData.demand_d = slide.text;

      if (slide.layerName === "demand E" && slide.text)
        dummyData.demand_e = slide.text;
      if (slide.layerName === "demand F" && slide.text)
        dummyData.demand_f = slide.text;
      if (slide.layerName === "meet A" && slide.text)
        dummyData.meet_a = slide.text;
      if (slide.layerName === "meet B" && slide.text)
        dummyData.meet_b = slide.text;

      if (slide.layerName === "spring A" && slide.text)
        dummyData.spring_a = slide.text;
      if (slide.layerName === "spring B" && slide.text)
        dummyData.spring_b = slide.text;
      if (slide.layerName === "spring C" && slide.text)
        dummyData.spring_c = slide.text;
      if (slide.layerName === "spring D" && slide.text)
        dummyData.spring_d = slide.text;

      if (slide.layerName === "spring E" && slide.text)
        dummyData.spring_e = slide.text;
      if (slide.layerName === "spring F" && slide.text)
        dummyData.spring_f = slide.text;
      if (slide.layerName === "spring G" && slide.text)
        dummyData.spring_g = slide.text;
      if (slide.layerName === "spring H" && slide.text)
        dummyData.spring_h = slide.text;

      if (slide.layerName === "holiday A" && slide.text)
        dummyData.holiday_a = slide.text;
      if (slide.layerName === "holiday B" && slide.text)
        dummyData.holiday_b = slide.text;

      if (slide.layerName === "hassels A" && slide.text)
        dummyData.hassels_a = slide.text;
      if (slide.layerName === "hassels B" && slide.text)
        dummyData.hassels_b = slide.text;

      if (slide.layerName === "ladder A" && slide.text)
        dummyData.ladder_a = slide.text;
      if (slide.layerName === "ladder B" && slide.text)
        dummyData.ladder_b = slide.text;
      if (slide.layerName === "ladder C" && slide.text)
        dummyData.ladder_c = slide.text;

      if (slide.layerName === "reach A" && slide.text)
        dummyData.reach_a = slide.text;
      if (slide.layerName === "reach B" && slide.text)
        dummyData.reach_b = slide.text;
      if (slide.layerName === "reach C" && slide.text)
        dummyData.reach_c = slide.text;

      if (slide.layerName === "worry A" && slide.text)
        dummyData.worry_a = slide.text;
      if (slide.layerName === "worry B" && slide.text)
        dummyData.worry_b = slide.text;

      if (slide.layerName === "plumbing A" && slide.text)
        dummyData.plumbing_a = slide.text;
      if (slide.layerName === "plumbing B" && slide.text)
        dummyData.plumbing_b = slide.text;
      if (slide.layerName === "plumbing C" && slide.text)
        dummyData.plumbing_c = slide.text;
      if (slide.layerName === "plumbing D" && slide.text)
        dummyData.plumbing_d = slide.text;
      if (slide.layerName === "plumbing E" && slide.text)
        dummyData.plumbing_e = slide.text;
      if (slide.layerName === "plumbing F" && slide.text)
        dummyData.plumbing_f = slide.text;
      if (slide.layerName === "plumbing G" && slide.text)
        dummyData.plumbing_g = slide.text;

      if (slide.layerName === "quality A" && slide.text)
        dummyData.quality_a = slide.text;
      if (slide.layerName === "quality B" && slide.text)
        dummyData.quality_b = slide.text;
      if (slide.layerName === "quality C" && slide.text)
        dummyData.quality_c = slide.text;

      if (slide.layerName === "money A" && slide.text)
        dummyData.money_a = slide.text;
      if (slide.layerName === "money B" && slide.text)
        dummyData.money_b = slide.text;
      if (slide.layerName === "money C" && slide.text)
        dummyData.money_c = slide.text;
      if (slide.layerName === "money D" && slide.text)
        dummyData.money_d = slide.text;

      if (slide.layerName === "needs A" && slide.text)
        dummyData.needs_a = slide.text;
      if (slide.layerName === "needs B" && slide.text)
        dummyData.needs_b = slide.text;

      if (slide.layerName === "professional A" && slide.text)
        dummyData.professional_a = slide.text;
      if (slide.layerName === "professional B" && slide.text)
        dummyData.professional_b = slide.text;
      if (slide.layerName === "professional C" && slide.text)
        dummyData.professional_c = slide.text;

      if (slide.layerName === "moments A" && slide.text)
        dummyData.moments_a = slide.text;
      if (slide.layerName === "moments B" && slide.text)
        dummyData.moments_b = slide.text;
      if (slide.layerName === "moments C" && slide.text)
        dummyData.moments_c = slide.text;
      if (slide.layerName === "moments D" && slide.text)
        dummyData.moments_d = slide.text;
      if (slide.layerName === "moments E" && slide.text)
        dummyData.moments_e = slide.text;

      if (slide.layerName === "trained A" && slide.text)
        dummyData.trained_a = slide.text;
      if (slide.layerName === "trained B" && slide.text)
        dummyData.trained_b = slide.text;
      if (slide.layerName === "trained C" && slide.text)
        dummyData.trained_c = slide.text;

      if (slide.layerName === "trained D" && slide.text)
        dummyData.trained_d = slide.text;

      if (slide.layerName === "master A" && slide.text)
        dummyData.master_a = slide.text;
      if (slide.layerName === "master B" && slide.text)
        dummyData.master_b = slide.text;
      if (slide.layerName === "master C" && slide.text)
        dummyData.master_c = slide.text;
      if (slide.layerName === "master D" && slide.text)
        dummyData.master_d = slide.text;

      if (slide.layerName === "need A" && slide.text)
        dummyData.need_a = slide.text;
      if (slide.layerName === "need B" && slide.text)
        dummyData.need_b = slide.text;
      if (slide.layerName === "need C" && slide.text)
        dummyData.need_c = slide.text;

      if (slide.layerName === "work A" && slide.text)
        dummyData.work_a = slide.text;
      if (slide.layerName === "work B" && slide.text)
        dummyData.work_b = slide.text;
      if (slide.layerName === "work C" && slide.text)
        dummyData.work_c = slide.text;
      if (slide.layerName === "work D" && slide.text)
        dummyData.work_d = slide.text;
      if (slide.layerName === "work F" && slide.text)
        dummyData.work_f = slide.text;
      if (slide.layerName === "work E" && slide.text)
        dummyData.work_e = slide.text.replace("  ", "<br />");

      if (slide.layerName === "suffer A" && slide.text)
        dummyData.suffer_a = slide.text;
      if (slide.layerName === "suffer B" && slide.text)
        dummyData.suffer_b = slide.text;

      if (slide.layerName === "result A" && slide.text)
        dummyData.result_a = slide.text;
      if (slide.layerName === "result B" && slide.text)
        dummyData.result_b = slide.text;
      if (slide.layerName === "result C" && slide.text)
        dummyData.result_c = slide.text;

      if (slide.layerName === "qualified A" && slide.text)
        dummyData.qualified_a = slide.text;
      if (slide.layerName === "qualified B" && slide.text)
        dummyData.qualified_b = slide.text;
      if (slide.layerName === "qualified C" && slide.text)
        dummyData.qualified_c = slide.text;
      if (slide.layerName === "qualified D" && slide.text)
        dummyData.qualified_d = slide.text;

      if (slide.layerName === "improve A" && slide.text)
        dummyData.improve_a = slide.text;
      if (slide.layerName === "improve B" && slide.text)
        dummyData.improve_b = slide.text;

      if (slide.layerName === "consultation A" && slide.text)
        dummyData.consultation_a = slide.text;
      if (slide.layerName === "consultation B" && slide.text)
        dummyData.consultation_b = slide.text;

      if (slide.layerName === "floor A" && slide.text)
        dummyData.floor_a = slide.text;
      if (slide.layerName === "floor B" && slide.text)
        dummyData.floor_b = slide.text;
      if (slide.layerName === "floor C" && slide.text)
        dummyData.floor_c = slide.text;
      if (slide.layerName === "floor D" && slide.text)
        dummyData.floor_d = slide.text;
      if (slide.layerName === "floor E" && slide.text)
        dummyData.floor_e = slide.text;

      if (slide.layerName === "further A" && slide.text)
        dummyData.further_a = slide.text;
      if (slide.layerName === "further B" && slide.text)
        dummyData.further_b = slide.text;

      if (slide.layerName === "provide A" && slide.text)
        dummyData.provide_a = slide.text;
      if (slide.layerName === "provide B" && slide.text)
        dummyData.provide_b = slide.text;
      if (slide.layerName === "provide C" && slide.text)
        dummyData.provide_c = slide.text;

      if (slide.layerName === "everyday A" && slide.text)
        dummyData.everyday_a = slide.text;

      if (slide.layerName === "Engageleads A" && slide.text)
        dummyData.engageleads_a = slide.text;
      if (slide.layerName === "Engageleads B" && slide.text)
        dummyData.engageleads_b = slide.text;
      if (slide.layerName === "Engageleads C" && slide.text)
        dummyData.engageleads_c = slide.text;
      if (slide.layerName === "Engageleads D" && slide.text)
        dummyData.engageleads_d = slide.text;
      if (slide.layerName === "Engageleads E" && slide.text)
        dummyData.engageleads_e = slide.text;
      if (slide.layerName === "Engageleads F" && slide.text)
        dummyData.engageleads_f = slide.text;
      if (slide.layerName === "Engageleads G" && slide.text)
        dummyData.engageleads_g = slide.text;
        if (slide.layerName === "Engageleads H" && slide.text)
        dummyData.engageleads_h = slide.text;
        if (slide.layerName === "Engageleads I" && slide.text)
        dummyData.engageleads_i = slide.text;
        if (slide.layerName === "Engageleads J" && slide.text)
        dummyData.engageleads_j = slide.text;
        if (slide.layerName === "Engageleads K" && slide.text)
        dummyData.engageleads_k = slide.text;
        if (slide.layerName === "Author A" && slide.text)
        dummyData.author_a = slide.text;
        if (slide.layerName === "Author B" && slide.text)
        dummyData.author_b = slide.text;
        if (slide.layerName === "Author C" && slide.text)
        dummyData.author_c = slide.text;

      if (slide.layerName === "Shape_layer" && slide.text)
        dummyData.Shape_layer = slide.text;
        if (slide.layerName === "Shape_layer_1" && slide.text)
        dummyData.Shape_layer_1 = slide.text;
      if (slide.layerName === "Shape_layer_2" && slide.text)
        dummyData.Shape_layer_2 = slide.text;

      if (slide.layerName === "icon_image" && slide.text)
      dummyData.icon_image = slide.text;


      return true;
    });

    // console.log(dummyData);
    return dispatch(campaignAction.setSlideData({ data: dummyData }));
    // }
  };

  const deleteSlide = (e, index) => {
    e.preventDefault();
    e.stopPropagation();
    var previewData = [...video_data];

    if (previewData.length === 1) {
      cuteToast({
        type: "error",
        message: "Atleast One Scene required!",
        timer: 5000,
        title: "",
      });
      return false;
    }

    previewData = previewData.filter((prev, key) => {
      return key !== index;
    });
    dispatch(campaignAction.deleteSlide({ previewData: previewData }));

    if (index === 0) {
      dispatch(
        campaignAction.doActiveSlide({
          active_slide_index: "",
          active_slide_name: "",
          single_slide_data: "",
        })
      );
    } else {
      makeActiveSlide(0);
    }

    cuteToast({
      type: "success",
      message: "Slide Deleted Successfully",
      timer: 5000,
      title: "",
    });
  };

  const playMovie = (e) => {
    e.target.play();
    // console.log(e);
    e.target.muted = true;
  };

  const stopMovie = (e) => {
    e.target.pause();
    e.target.load();
  };

  return (
    <li className={`${active_slide_index === id ? "activeSlide" : ""}`} onClick={() => {
      makeActiveSlide(id);
    }}>
      <div className={`series_vd content ${verticalContent} position-relative`}>
        {active_slide_index === id && (
          <div className="scene_counter pull-left">
            {active_slide_index + 1}
          </div>
        )}
        <a
          href="#0"
          className="deleteSlide"
          onClick={(e) => deleteSlide(e, id)}
        >
          <i className="fa fa-trash"></i>
        </a>
        <video
          // onClick={() => {
          //   makeActiveSlide(id);
          // }}
          src={single_slide.preview_url}
          poster={single_slide.thumbnail}
          //   preload="none"
          loop
          height={vheight}
          width="100%"
          onMouseOver={playMovie}
          onMouseOut={stopMovie}
        />
      </div>
    </li>
  );
};

export default SingleSlide;
